import React from "react";
import classNames from "classnames";
import { useParams } from "react-router";
import useSWR from "swr";
import { useStores } from "hooks/useStores";
import style from "../styles/ng_detail.module.scss";
import HowChoiceSwitch from "components/HowChoiceSwitch";

const HowChoose = ({ isActive = false }) => {
  const { slug } = useParams();
  const { api } = useStores();

  const { data, isLoading } = useSWR(
    { slug, _key: `how-choose-${slug}` },
    api.newCatalog.getNomenclatureGroupHowChoice
  );

  const panelClasses = classNames({
    [style.tab__panel]: true,
    [style["tab__panel--active"]]: isActive,
  });

  return (
    <div className={panelClasses}>
      <div className={style.container}>
      {!isLoading &&
        data.how_choice_components.map(
          (item) => 
          <HowChoiceSwitch
            key={item.id}
            component_type={item.component_type}
            properties={item.properties}
          />
        )}
      </div>
    </div>
  );
};

export default HowChoose;
